import { faArrowDownShortWide, faLocationDot, faStar, faWallet, IconDefinition } from '@fortawesome/pro-light-svg-icons';

export enum SearchFilterOrderType {
  DEFAULT = 'all',
  PRICE = 'price',
  DISTANCE = 'distance',
  RATING = 'rating',
}

export interface SearchFilterOrderProps {
  name: string;
  icon: IconDefinition;
}

export interface OrderOptionsProps {
  value: SearchFilterOrderType;
  title: string;
  icon: IconDefinition;
}

export const SearchFilterOrderMap: Record<SearchFilterOrderType, SearchFilterOrderProps> = {
  [SearchFilterOrderType.DEFAULT]: {
    name: 'Ordenação padrão',
    icon: faArrowDownShortWide,
  },
  [SearchFilterOrderType.PRICE]: {
    name: 'Mais baratos',
    icon: faWallet,
  },
  [SearchFilterOrderType.DISTANCE]: {
    name: 'Mais próximos',
    icon: faLocationDot,
  },
  [SearchFilterOrderType.RATING]: {
    name: 'Melhor avaliação',
    icon: faStar,
  },
};
